import { type FC } from 'react'
import { type DefaultProps } from '../common'

export const IconConfirmationCircle: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <rect width={38.5} height={38.5} x={0.75} y={0.75} stroke="#148338" strokeWidth={1.5} rx={19.25} />
      <path
        stroke="#148338"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m12 20.857 4.571 4.572L28 14"
      />
    </svg>
  )
}
